var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddress = function SvgAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M5.5 12.609c-1.78.165-3 .502-3 .891 0 .552 2.462 1 5.5 1s5.5-.448 5.5-1c0-.389-1.22-.726-3-.891"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8.794 10.937-.079-.493a.5.5 0 0 0-.388.314zm-1.588 0 .467-.18a.5.5 0 0 0-.388-.313zM8 13l-.467.18a.5.5 0 0 0 .934 0zm4.5-7a4.5 4.5 0 0 1-3.785 4.444l.158.987A5.5 5.5 0 0 0 13.5 6zM8 1.5A4.5 4.5 0 0 1 12.5 6h1A5.5 5.5 0 0 0 8 .5zM3.5 6A4.5 4.5 0 0 1 8 1.5v-1A5.5 5.5 0 0 0 2.5 6zm3.785 4.444A4.5 4.5 0 0 1 3.5 6h-1a5.5 5.5 0 0 0 4.627 5.431zm-.546.673.794 2.063.934-.36-.794-2.062zm1.728 2.063.794-2.063-.934-.36-.794 2.063z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M8 7a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }))));
};
export default SvgAddress;